"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const assert_1 = __importDefault(require("assert"));
const logger_1 = require("@upflowy/logger");
const graph_1 = require("@xstate/graph");
const lodash_1 = require("lodash");
const xstate_1 = require("xstate");
const helper_1 = require("./helper");
const node_factory_1 = __importDefault(require("./node-factory"));
function getNodeId(node) {
    const graphNodeId = typeof node === 'string' ? node : node === null || node === void 0 ? void 0 : node.id;
    return graphNodeId === null || graphNodeId === void 0 ? void 0 : graphNodeId.substring(graphNodeId.indexOf('.') + 1);
}
function nodeType(nodeConfig) {
    var _a, _b, _c, _d, _e, _f, _g;
    if (((_a = nodeConfig === null || nodeConfig === void 0 ? void 0 : nodeConfig.config) === null || _a === void 0 ? void 0 : _a.meta) &&
        'stepId' in ((_b = nodeConfig === null || nodeConfig === void 0 ? void 0 : nodeConfig.config) === null || _b === void 0 ? void 0 : _b.meta) &&
        ((_c = nodeConfig === null || nodeConfig === void 0 ? void 0 : nodeConfig.config) === null || _c === void 0 ? void 0 : _c.meta.stepId)) {
        return 'stepNode';
    }
    if (((_e = (_d = nodeConfig === null || nodeConfig === void 0 ? void 0 : nodeConfig.config) === null || _d === void 0 ? void 0 : _d.meta) === null || _e === void 0 ? void 0 : _e.type) === 'external') {
        return 'externalNode';
    }
    if (((_g = (_f = nodeConfig === null || nodeConfig === void 0 ? void 0 : nodeConfig.config) === null || _f === void 0 ? void 0 : _f.meta) === null || _g === void 0 ? void 0 : _g.type) === 'end') {
        return 'endNode';
    }
    return 'transient';
}
function createNode(nodeId, nodeConfig) {
    var _a;
    const type = nodeType(nodeConfig);
    const meta = (_a = nodeConfig === null || nodeConfig === void 0 ? void 0 : nodeConfig.config) === null || _a === void 0 ? void 0 : _a.meta;
    if (type === 'stepNode') {
        return {
            id: nodeId,
            type,
            config: {
                stateNodeConfig: nodeConfig === null || nodeConfig === void 0 ? void 0 : nodeConfig.config,
                stepId: meta && 'stepId' in meta ? meta.stepId : '',
            },
        };
    }
    if (type === 'endNode') {
        return {
            id: nodeId,
            type,
            config: {
                stateNodeConfig: nodeConfig === null || nodeConfig === void 0 ? void 0 : nodeConfig.config,
                redirectUrl: meta && 'redirectUrl' in meta ? meta.redirectUrl : undefined,
                action: meta && 'action' in meta && meta.action === 'redirect' ? 'redirect' : 'close',
            },
        };
    }
    return {
        id: nodeId,
        type,
        config: {
            stateNodeConfig: nodeConfig === null || nodeConfig === void 0 ? void 0 : nodeConfig.config,
        },
    };
}
function pathToString(path) {
    return path.map((n) => n.id).join(',');
}
function pathsToString(paths) {
    return paths.map((p) => pathToString(p)).join('; ');
}
function isEndPath(path) {
    const lastNode = path[path.length - 1];
    if ((lastNode === null || lastNode === void 0 ? void 0 : lastNode.type) === 'endNode')
        return true;
    if ((lastNode === null || lastNode === void 0 ? void 0 : lastNode.type) === 'condNode') {
        return lastNode.paths.every((p) => isEndPath(p.path));
    }
    return false;
}
function addEndNode(path) {
    return isEndPath(path) ? path : [...path, node_factory_1.default.end()];
}
function extractAbTestConfig(nodeConfig) {
    var _a, _b, _c;
    const extract = (action) => {
        if (!action || typeof action !== 'object' || (action === null || action === void 0 ? void 0 : action.type) !== 'startAbTest') {
            logger_1.logger.warn('No valid abTestEntry for abTestNode', { nodeConfig });
            return { name: 'invalid', variations: [] };
        }
        return {
            name: action.name,
            variations: action.variations,
        };
    };
    if ((0, lodash_1.isArray)((_a = nodeConfig.config) === null || _a === void 0 ? void 0 : _a.entry)) {
        const action = (_b = nodeConfig.config) === null || _b === void 0 ? void 0 : _b.entry.find((e) => typeof e === 'object' && e.type === 'startAbTest');
        return extract(action);
    }
    return extract((_c = nodeConfig.config) === null || _c === void 0 ? void 0 : _c.entry);
}
function createConditionalPath(targetPaths, nodeConfig) {
    var _a, _b, _c;
    let nodeId = nodeConfig.id;
    const result = [];
    if (nodeType(nodeConfig) === 'stepNode') {
        result.push(createNode(nodeId, nodeConfig));
        nodeId += '-cond';
    }
    const meta = (_a = nodeConfig === null || nodeConfig === void 0 ? void 0 : nodeConfig.config) === null || _a === void 0 ? void 0 : _a.meta;
    const node = {
        id: nodeId,
        paths: targetPaths.map((p, index) => {
            var _a, _b, _c, _d;
            const target = nodeConfig.targets[index];
            return {
                path: p.path,
                cond: target === null || target === void 0 ? void 0 : target.cond,
                name: ((_a = target === null || target === void 0 ? void 0 : target.meta) === null || _a === void 0 ? void 0 : _a.name) ? String((_b = target === null || target === void 0 ? void 0 : target.meta) === null || _b === void 0 ? void 0 : _b.name) : undefined,
                id: ((_c = target === null || target === void 0 ? void 0 : target.meta) === null || _c === void 0 ? void 0 : _c.id) ? String((_d = target === null || target === void 0 ? void 0 : target.meta) === null || _d === void 0 ? void 0 : _d.id) : (0, helper_1.shortUuid)(),
                meta: target === null || target === void 0 ? void 0 : target.meta,
            };
        }),
        splitNode: nodeId,
        joinNode: (_c = (_b = targetPaths[0]) === null || _b === void 0 ? void 0 : _b.joinNodeId) !== null && _c !== void 0 ? _c : '',
    };
    result.push((meta === null || meta === void 0 ? void 0 : meta.type) === 'abTest'
        ? {
            ...node,
            type: 'abTestNode',
            ...extractAbTestConfig(nodeConfig),
        }
        : {
            type: 'condNode',
            ...node,
        });
    return result;
}
// eslint-disable-next-line sonarjs/cognitive-complexity
function getPath(state, config, splitNodeId) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    let currentNode = state.node;
    const path = [];
    const { initial } = config.machineConfig;
    while (currentNode) {
        const nodeConfig = config.nodes[currentNode];
        if (!nodeConfig)
            throw new Error('Node config should be defined');
        const targets = (nodeConfig === null || nodeConfig === void 0 ? void 0 : nodeConfig.targets) || [];
        if ((((_b = (_a = nodeConfig.config) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.type) === 'join' &&
            ((_c = nodeConfig.config.meta) === null || _c === void 0 ? void 0 : _c.splitStateId) === splitNodeId) ||
            (currentNode === initial && path.length > 0) ||
            (currentNode !== initial &&
                ((_e = (_d = config.nodes[currentNode]) === null || _d === void 0 ? void 0 : _d.sources.length) !== null && _e !== void 0 ? _e : 0) > 1 &&
                !state.completedJoins.has(currentNode))) {
            return {
                path,
                joinNodeId: currentNode,
                joinCount: currentNode === initial ? 0 : 1,
            };
        }
        if (targets.length > 1) {
            // Branch
            const targetPaths = targets.map((target) => getPath({
                ...state,
                node: target.nodeId,
            }, config, nodeConfig === null || nodeConfig === void 0 ? void 0 : nodeConfig.id));
            const pathStr = `${currentNode}: ${pathsToString(targetPaths.map((p) => p.path))}`;
            const joins = targetPaths.filter((p) => p.joinNodeId && p.joinNodeId !== initial);
            const joinNodeId = (_f = joins[0]) === null || _f === void 0 ? void 0 : _f.joinNodeId;
            if (joins.some((p) => p.joinNodeId !== joinNodeId)) {
                throw Error(`Split ${pathStr} does not join up`);
            }
            const joinCount = targetPaths.map((p) => p.joinCount).reduce((p, c) => p + c, 0);
            path.push(...createConditionalPath(targetPaths, nodeConfig));
            if (!joinNodeId || joinCount !== ((_g = config.nodes[joinNodeId]) === null || _g === void 0 ? void 0 : _g.sources.length)) {
                return {
                    path,
                    joinCount,
                    joinNodeId,
                };
            }
            const joinNode = config.nodes[joinNodeId];
            (0, assert_1.default)(joinNode);
            state.completedJoins.add(joinNodeId);
            if (joinNode.targets.length < 2) {
                if (!((_h = joinNode.targets[0]) === null || _h === void 0 ? void 0 : _h.nodeId))
                    break;
                currentNode = (_j = joinNode.targets[0]) === null || _j === void 0 ? void 0 : _j.nodeId;
            }
            else {
                currentNode = joinNodeId;
            }
        }
        else if (targets.length === 0) {
            path.push(createNode(currentNode, nodeConfig));
            break;
        }
        else {
            if (state.visited.has(currentNode)) {
                if (config.handleLoops) {
                    break;
                }
                else {
                    throw new Error('state has loop');
                }
            }
            state.visited.add(currentNode);
            path.push(createNode(currentNode, nodeConfig));
            const target = targets[0];
            (0, assert_1.default)(target);
            currentNode = target.nodeId;
        }
    }
    return {
        path,
        joinCount: 0,
    };
}
function xstateToFlowPath(machineConfig, config = {
    handleLoops: true,
}, events = [
    {
        type: 'SUBMIT',
    },
    {
        type: 'FLOW_TRIGGER',
    },
]) {
    var _a, _b;
    if (!(machineConfig === null || machineConfig === void 0 ? void 0 : machineConfig.initial) || !((_a = machineConfig === null || machineConfig === void 0 ? void 0 : machineConfig.states) === null || _a === void 0 ? void 0 : _a[machineConfig === null || machineConfig === void 0 ? void 0 : machineConfig.initial])) {
        return [node_factory_1.default.origin()];
    }
    const machine = (0, xstate_1.createMachine)(machineConfig, {});
    const graph = (0, graph_1.toDirectedGraph)(machine);
    const nodes = {};
    graph.children.forEach((c) => {
        nodes[getNodeId(c.id)] = {
            id: getNodeId(c.id),
            config: c.stateNode.config,
            sources: [],
            targets: [],
        };
    });
    graph.children.forEach((c) => c.edges
        .filter((e) => events.some((event) => e.label.text === '' || event.type === e.label.text))
        .forEach((edge) => {
        var _a, _b, _c, _d, _e, _f;
        const sourceNode = (_a = nodes[getNodeId(edge.source)]) !== null && _a !== void 0 ? _a : {
            id: getNodeId(edge.source),
            sources: [],
            targets: [],
        };
        const targetNode = (_b = nodes[getNodeId(edge.target)]) !== null && _b !== void 0 ? _b : {
            id: getNodeId(edge.target),
            sources: [],
            targets: [],
        };
        sourceNode.targets.push({
            nodeId: getNodeId(edge.target),
            cond: (_d = (_c = edge.transition) === null || _c === void 0 ? void 0 : _c.cond) === null || _d === void 0 ? void 0 : _d.name,
            meta: (_f = (_e = edge.transition) === null || _e === void 0 ? void 0 : _e.meta) !== null && _f !== void 0 ? _f : {},
        });
        targetNode.sources.push(getNodeId(edge.source));
        nodes[getNodeId(edge.source)] = sourceNode;
        nodes[getNodeId(edge.target)] = targetNode;
    }));
    const unConnectedNodes = Object.values(nodes).filter((node) => node.id !== machineConfig.initial && node.sources.length === 0);
    if (unConnectedNodes.length > 0) {
        logger_1.logger.error(`Unconnected states found: ${unConnectedNodes.map((n) => n.id).join(',')}`);
    }
    const { path } = getPath({
        visited: new Set(),
        pathVisited: new Set(),
        node: `${machineConfig.initial}`,
        completedJoins: new Set(),
    }, {
        nodes,
        machineConfig,
        graph,
        handleLoops: config.handleLoops,
    });
    const pathWithEnd = addEndNode(path);
    return ((_b = path[0]) === null || _b === void 0 ? void 0 : _b.id) === machineConfig.initial
        ? pathWithEnd
        : [node_factory_1.default.origin(), ...pathWithEnd];
}
exports.default = xstateToFlowPath;
//# sourceMappingURL=xstate-to-flow-path.js.map